import { render, staticRenderFns } from "./PSkillTagList.vue?vue&type=template&id=9cf42b1e&scoped=true&"
import script from "./PSkillTagList.vue?vue&type=script&lang=ts&"
export * from "./PSkillTagList.vue?vue&type=script&lang=ts&"
import style0 from "./PSkillTagList.vue?vue&type=style&index=0&id=9cf42b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf42b1e",
  null
  
)

export default component.exports